import CONSTANTS from "../CONSTANTS"
import axios from "axios"
import apiControllers from "./apiControllers"
// import data_service from "../assets/demo/mockservicereports.json"


const API_URL = CONSTANTS.API_URL
// const API_URL = CONSTANTS.LOCAL_API_URL


const API = {
    pushPlantServiceReportToDB(data){
        axios.post(CONSTANTS.PLANT_SERVICE, data)
        .then(res=>{
            console.log('in Tehn')
            console.log(res)
        })
        .catch(err=>{ console.log(err)})

    },
    createQuotationAPI(data) {
        let body = apiControllers.gunQuotationControllers(data)
        console.log(body)
        let url = API_URL + "api/quotation"
        return new Promise((resolve, reject) => {
            // let url ="http://localhost:5001/api/quotation"
            axios.post(url, body).then((res) => {
                console.log("Quotation Saved Sucessfully!!!")
                console.log('Saved Data: ', res)
                resolve(res)
            }).catch((err) => {
                console.log(err)
                reject(err)
            })
        })

    },
    getAllQuotations(){
        return new Promise((resolve, reject)=>{
            axios.get(`${API_URL}api/quotation`).then((response)=>{
                if(response.data){
                    resolve(response.data)
                } else reject("No data Found")
            }).catch((err)=>{
                reject(err)
            })
        })
    },
    getSingleQuotations(id){
        return new Promise((resolve, reject)=>{
            axios.get(`${API_URL}api/quotation/${id}`).then((response)=>{
                if(response.data){
                    resolve(response.data)
                } else reject("No data Found")
            }).catch((err)=>{
                reject(err)
            })
        })
    },
    deleteQuotation(id){
        return new Promise((resolve, reject)=>{
            axios.delete(`${API_URL}api/quotation/${id}`).then((response)=>{
                if(response.data){
                    resolve(response.data)
                } else reject("No data Found")
            }).catch((err)=>{
                reject(err)
            })
        })
    },
    addClient(data){
        let body = apiControllers.getAddClientPayload(data);

        return new Promise((resolve, reject)=>{
            axios.post(`${API_URL}api/client`,body).then((response)=>{
                if(response.data){
                    resolve(response.data)
                } else reject("No Client Added, Some Error Occured")
            }).catch((err)=>{
                reject(err)
            })
        })
    },
    getAllClient() {
        try {

            return new Promise((resolve, reject) => {
                axios.get(`${API_URL}api/client`).then((response) => {
                    if (response.data) {
                        resolve(response.data)
                    } else reject("No Client List Found, Some Error Occured")
                }).catch((err) => {
                    reject(err)
                })
            })
        } catch (err) {
            console.log(err)
        }
    },
    removeClient(id){
        return new Promise((resolve, reject)=>{
            axios.delete(`${API_URL}api/client/single/${id}`).then((response)=>{
                if(response.data){
                    resolve(response.data)
                } else reject("No Client List Found, Some Error Occured")
            }).catch((err)=>{
                reject(err)
            })
        })
    },
    saveServiceReportAPI(body){
        console.log(body)
        return new Promise((resolve, reject)=>{
            axios.post(`${API_URL}api/reports/addReport`,body).then((response)=>{
                if(response.data){
                    resolve(response.data)
                } else reject("No Report Added, Some Error Occured")
            }).catch((err)=>{
                reject(err)
            })
        })
    },
    getreports(){
        return new Promise((resolve, reject)=>{
            axios.get(`${API_URL}api/reports/allReports`).then((response)=>{
                if(response.data){
                    resolve(response.data)
                } else reject("No Report Found, Some Error Occured")
            }).catch((err)=>{
                reject(err)
            })
        })
    },
    getServicesByMail(){
        return new Promise((resolve, reject)=>{
            axios.get(`${API_URL}api/service`).then((response)=>{
                if(response.data){
                    resolve(response.data)
                } else reject("No Report Found, Some Error Occured")
            }).catch((err)=>{
                reject(err)
            })
        })
    },
    deleteReport(id){
        return new Promise((resolve, reject)=>{
            axios.delete(`${API_URL}api/reports/single/${id}`).then((response)=>{
                if(response.data){
                    resolve(response.data)
                } else reject("No Report Found to delete, Some Error Occured")
            }).catch((err)=>{
                reject(err)
            })
        })
    },
    getLeads(){
        return new Promise((resolve, reject)=>{
            axios.get(`${API_URL}api/leads`).then((response)=>{
                if(response.data){
                    resolve(response.data)
                } else reject("No Report Found, Some Error Occured")
            }).catch((err)=>{
                reject(err)
            })
        })
    },
    saveServiceByMailTool(body){
        console.log(body)
        return new Promise((resolve, reject)=>{
            axios.post(`${API_URL}api/service`,body).then((response)=>{
                if(response.data){
                    resolve(response.data)
                } else reject("No Report Added, Some Error Occured")
            }).catch((err)=>{
                reject(err)
            })
        })
    }
}


export default API